<template>
  <tk-btn
    v-if="lift.path || lift.url"
    dark
    color="black"
    large
    :to="lift.is_redirectable ? null : { path: lift.path}"
    :href="lift.is_redirectable ? lift.url : null"
    :target="lift.is_redirectable ? '_blank' : null"
    :rel="lift.is_redirectable ? 'noreferrer' : null"
    class="lift-link-btn"
  >
    <TranslationDisplay
      tag="div"
      class="caption font-weight-medium"
      :translation="lift.btn_title"
    />
  </tk-btn>
</template>

<script>
import Vue from 'vue'
import TranslationDisplay from '../../base/Translation/TranslationDisplay.vue'

export default Vue.extend({
  name: 'LiftLinkBtn',
  components: { TranslationDisplay },
  props: {
    lift: {
      type: Object,
      required: true
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>
.lift-link-btn {
  margin-left: 0;
}
</style>